import { render, staticRenderFns } from "./KpiGrid.vue?vue&type=template&id=5f80cf9a&scoped=true"
import script from "./KpiGrid.vue?vue&type=script&lang=js"
export * from "./KpiGrid.vue?vue&type=script&lang=js"
import style0 from "./KpiGrid.vue?vue&type=style&index=0&id=5f80cf9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80cf9a",
  null
  
)

export default component.exports